// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Q1dd","productName":"Table_productName__3N4dM"};